export default __webpack_public_path__ + "static/media/lever_rgb_mark_standard.1ad538af.svg";